export default {
  '400': 'Mä jani walt\'awiwa utji.',
  '401': 'Sart\'awimaxa tukuyxiwa.',
  '412': 'Janiwa luraskiti',
  '403': 'Janiwa utjkiti suma iyasañanakaxa.',
  '404': 'Kuntixa thaqhtaxa janiwa utjkiti.',
  '407': 'Wakichañawa proxypaxa, apnaqañataki.',
  '408': 'Servidoraxa janiwa jayskiti. ukatjaru yant\'ama.',
  '409': 'Qillqatamaxa janiwa walikiti.',
  '410': 'Kuntixa maytaxa janiwa utjkiti, ukhamarusa janiwa utjkaniti.',
  '500': 'Pantxasiwa servidoraxa, ukatjaru yant\'ama.',
  '502': 'Atamiri kipuxa janiwa walikiti, ukatjaru yant\'ama.',
  '503': 'Atamiri kipuxa janiwa anchitaxa irnaqkiti,  ukatjaru yant\'ama ampsuma.',
  // '504': 'Gateway timeout - Tiempo de espera agotado.', // Esto debe ser implementado en el frontend para reintentar las peticiones
  'connection': 'Janiwa servidorampixa arust\'asiñxamakiti.',
  'cancelRequest': 'Mayiwi tukuyaña.',
  'validation': 'Janiwa walikiti.',
  'unknown': 'Janiwa jani walt\'awi yatiskiti, ukatjaru yant\'ama.',
  'sessionExpired': 'Sart\'awimaxa tukusxiwa, machaqata mantanim.'
};



// WEBPACK FOOTER //
// ./src/common/lang/ay/errors.js